import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";
import SharedHeader from "../../../generic-components/shared-header/SharedHeader";
import Loader from "../../../generic-components/loader";
import ManageMySharedCostWithNoPlans from "./manage-my-shared-cost-content/ManageMySharedCostWithNoPlans";
import ManageMySharedCostWithPlans from "./manage-my-shared-cost-content/ManageMySharedCostWithPlans";
import usePlan from "../../../../hooks/usePlan";
import usePlanDetails from "../../../../hooks/usePlanDetails";

const ManageMySharedCostAVCPage = ({ user }) => {
  const { plans } = usePlan();
  const { fetchCompletePlanDetails, isPlanLoading } = usePlanDetails();

  useEffect(() => {
    if (user.id && user.organisation_id) {
      fetchCompletePlanDetails(user.id, user.organisation_id, true);
    }
  }, [user.organisation_id, user.id]);

  return (
    <Box className="application-page-container space-from-top">
      <SharedHeader heading="My Shared Cost AVC" />
      {isPlanLoading ? (
        <Box className="mt-200">
          <Loader />
        </Box>
      ) : plans?.length ? (
        <>
          <ManageMySharedCostWithPlans plans={plans} />
          <Box className="home-detail-section back-img-sm"></Box>
        </>
      ) : (
        <>
          <ManageMySharedCostWithNoPlans />
          <Box className="home-detail-section back-img-sm"></Box>
        </>
      )}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state?.user?.user,
  };
};

ManageMySharedCostAVCPage.propTypes = {
  user: PropTypes.object,
};

export default connect(mapStateToProps)(ManageMySharedCostAVCPage);
